import axios from "../../../config/axiosConfig";

export const listarProgramacionesEquipo = (params = {}) =>
  axios.get("/api/programacion-equipo", { params });

export const listarEquiposProgramados = (params = {}) =>
  axios.get("/api/programacion-equipo/equipos-programados", { params });

export const buscarModemsInactivos = (params = {}) =>
  axios.get("/api/programacion-equipo/catalogo/modems", { params });

export const buscarChipsInactivos = (params = {}) =>
  axios.get("/api/programacion-equipo/catalogo/chips", { params });

export const listarPlataformasRastreo = () =>
  axios.get("/api/programacion-equipo/plataformas-rastreo");

export const crearProgramacionEquipo = (body = {}) =>
  axios.post("/api/programacion-equipo", body);

export const editarEquipoProgramado = (numSim, body = {}) =>
  axios.put(`/api/programacion-equipo/equipos-programados/${encodeURIComponent(numSim)}`, body);

export const desprogramarEquipoProgramado = (numSim, body = {}) =>
  axios.post(`/api/programacion-equipo/equipos-programados/${encodeURIComponent(numSim)}/desprogramar`, body);
